// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.display-text[data-v-3da75d7c]{display:flex;flex-direction:column}.display-text.bold[data-v-3da75d7c]{font-weight:bold}`, "",{"version":3,"sources":["webpack://./client/components/Display/DisplayText.vue"],"names":[],"mappings":"AAGA,+BACE,YAAA,CACA,qBAAA,CAEA,oCACE,gBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
